import { useTranslation } from "react-i18next"

import { PageSection } from "../../../components"
import TransMsg from "../../transMessage";
import {VideoCardComponent} from "./VideoCardComponent";

export const FeaturedContent = () => {
    const { t } = useTranslation()
    return (
        <PageSection
            title={t(TransMsg.FEATURED_CONTENT)}
            description={t(TransMsg.FEATURED_CONTENT_DESCRIPTION)}
            descriptionSx={{ mt: "38px", fontSize: "16.17px", color: "#393939" }}
            subTitleSx={{ mt: "38px", color: "#A62C4E" }}
            customElement={<VideoCardComponent t={t} />}
        />
    )
}
